import tokenHttpClient from "../utils/httpClient";
import { post } from "../utils/httpClient-methods";
import { API_URL, BASE_URL_MASTERS, BASE_URL } from "../utils/AppApiUrl";


export const UserListingService = async (baseURL, requestBody) => {
  try {
    const userListingRequestObj = {
      active: requestBody?.status,
      pageNumber: requestBody?.pageNumber,
      pageSize: requestBody?.pageSize,
      filterSearch: requestBody?.filterSearch ?? null,
      sortDirection: requestBody?.sortDirection ?? null,
      sortBy: requestBody?.sortBy ?? null,
    };
    const userListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.userListing}`,
      userListingRequestObj
    );
    
    // add condition here to check
    if (userListingResponse.status === 200) {
      return userListingResponse;
    } else {
      return {};
    }
  } catch (err) {
    console.log("err", err);
    throw err;
  }
};

export const UserListingSearchService = async (
  baseURL,
  requestBody,
  searchValue
) => {
  try {
    const userListingRequestObj = {
      active: requestBody?.status,
      pageNumber: requestBody?.pageNumber,
      pageSize: requestBody?.pageSize,
      filterSearch: searchValue,
      sortDirection: requestBody?.sortDirection ?? null,
      sortBy: requestBody?.sortBy ?? null,
    };
    const userListingResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.userListing}`,
      userListingRequestObj
    );
    // add condition here to check
    if (userListingResponse.status === 200) {
      return userListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const UserChangeStatusService = async (requestBody) => {
  try {
    const userStatusResponse = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.changeUserStatus}`,
      requestBody
    );
    // add condition here to check
    if (userStatusResponse.status === 200) {
      return userStatusResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const onAddUserService = async (
  BASE_URL,
  values,
  data,
  checkEmailType
) => {
  try {
    const requestBody = {
      createdBy: values?.createdBy ?? 0,
      employeeId: values?.employeeId ?? null,
      mobileNumber: values?.mobileNumber ?? "string",
      modifiedBy: values?.modifedBy ?? null,
      modifiedOn: values?.modifiedOn ?? null,
      password: values?.password ?? null,
      tempToken: values?.tempToken ?? "string",
      ...data,
      active: data && data.active === "false" ? false : true,
      userTypeId: data && data.userTypeId ? parseInt(data.userTypeId) : null,
      roleId: data && data.roleId ? parseInt(data.roleId) : null,
      deptId: data && data.deptId ? parseInt(data.deptId) : null,
      createdOn: values?.createdOn ?? new Date(),
      roleName: values?.roleName ?? null,
      deptName: values?.deptName ?? null,
      userTypeName: values?.userTypeName ?? null,
    };
    const saveUserDetails = await post(
      tokenHttpClient,
      `${BASE_URL}${
        checkEmailType
          ? API_URL.saveOnboardUserDetails
          : API_URL.nonRilSaveOnboardUserDetails
      }`,
      requestBody
    );
    if (saveUserDetails.status === 200) {
      return saveUserDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const onEditUserService = async (
  BASE_URL,
  values,
  userId,
  checkEmailType
) => {
  try {
    const requestBody = {
      createdBy: values?.createdBy ?? 0,
      employeeId: values?.employeeId ?? "string",
      mobileNumber: values?.mobileNumber ?? "string",
      modifiedBy: values?.modifiedBy ?? null,
      password: values?.password ?? null,
      tempToken: values?.tempToken ?? "string",
      active: values.active,
      userTypeId:
        values && values.userTypeId ? parseInt(values.userTypeId) : null,
      roleId: values && values.roleId ? parseInt(values.roleId) : null,
      deptId: values && values.deptId ? parseInt(values.deptId) : null,
      deptName: values?.deptName ?? null,
      email: values?.email ?? "",
      firstName: values?.firstName ?? "",
      lastName: values?.lastName ?? "",
      roleName: values?.roleName ?? null,
      userTypeName: values?.userTypeName ?? null,
      createdOn: values?.createdOn,
      modifiedOn: new Date(),
    };
    const saveUserDetails = await post(
      tokenHttpClient,
      `${BASE_URL}${
        checkEmailType
          ? API_URL.updateOnboardUserDetails
          : API_URL.nonRilUpdateOnboardUserDetails
      }/${userId}`,
      requestBody
    );
    if (saveUserDetails.status === 200) {
      return saveUserDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const DepartmentListingService = async (requestBody) => {
  try {
    const departmentListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${API_URL.departmentListing}`,
      requestBody
    );
    // add condition here to check
    if (departmentListingResponse.status === 200) {
      return departmentListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const RoleListingService = async (requestObject) => {
  try {
    const roleListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${API_URL.roleListing}`,
      requestObject
    );
    // add condition here to check
    if (roleListingResponse.status === 200) {
      return roleListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const UserTypeListingService = async () => {
  try {
    const userTypeListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${API_URL.userTypeListing}`,
      null
    );
    // add condition here to check
    if (userTypeListingResponse.status === 200) {
      return userTypeListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const UserRolesDetailsService = async () => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.userRolesDetails}`,
      null
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const UserRoleAccessService = async (id) => {
  try {
    const param = {
      userRoleMappingId: id,
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.userRoleAccess}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
export const UserRoleAccessInsideUsersPageService = async (id) => {
  try {
    const param = {
      userId: id,
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.userUserRoleAccess}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      const { data } = response;
      return data;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
export const AddRoleAccessService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.addRoleAccess}`,
      // nonRilAddRoleAccess
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const EditUserRoleAccessInsideUsersPageService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.editUserRolePermission}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const UnlockUserService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.unlockUser}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
export const departmentsListingSearchService = async (
  requestBody,
  searchValue
) => {
  try {
    const departmentListingRequestObj = {
      active: requestBody?.active,
      pageNumber: requestBody?.pageNumber,
      pageSize: requestBody?.pageSize,
      filterSearch: searchValue,
      sortBy: "name",
      sortDirection: "ASC",
    };
    //console.log('values sea',departmentListingRequestObj)
    const departmentListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.departmentsListing}`,
      departmentListingRequestObj
    );
    // add condition here to check
    if (departmentListingResponse.status === 200) {
      return departmentListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
export const departmentsListingService = async (values) => {
  try {
    
    const departmentListingResponse = await post(
      tokenHttpClient,
    `${BASE_URL}${API_URL.departmentsListing}`,
      values
    );
    // add condition here to check
    if (departmentListingResponse.status === 200) {
      return departmentListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
export const onUpdateDepartmentService = async (values) => {
  try {
    const requestBody = {
      deptCode: values?.deptCode ?? "",
      name: values?.name ?? "",
      departmentId: values?.departmentId ?? null,
      modifiedBy: values?.modifiedBy ?? null,
      modifiedOn: new Date(),
      createdOn: values?.createdOn,
      createdBy: values?.createdBy ?? 1,
      active: values?.active,
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.updateDepartmentDetails}`,
      requestBody
    );
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    console.log('err',err)
    throw err;
  }
};
export const departmentsChangeStatusService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.changeDepartmentStatus}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const onAddDepartmentsService = async (values) => {
  try {
    const requestBody = {
      deptCode: values?.deptCode ?? "",
      name: values?.name ?? "",
      departmentId: values?.departmentId ?? null,
      modifiedBy: values?.modifiedBy ?? null,
      modifiedOn: values?.modifiedOn ?? null,
      createdOn: values?.createdOn,
      createdBy: values?.createdBy ?? 1,
      active: values?.active,
    };
    const saveDepartmentetails = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.addDepartmentDetails}`,
      requestBody
    );
    if (saveDepartmentetails.status === 200) {
      return saveDepartmentetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

// function services
export const functListingSearchService = async (requestBody, searchValue) => {
  try {
    const familyListingRequestObj = {
      active: requestBody?.active,
      pageNumber: requestBody?.pageNumber,
      pageSize: requestBody?.pageSize,
      filterSearch: searchValue,
      sortBy: "name",
      sortDirection: "ASC",
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.FunctionListing}`,
      familyListingRequestObj
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const departmentListingService = async (values) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.departmentsListing}`,
      values
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const functionListingService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.FunctionListing}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const onUpdateFunctionService = async (values) => {
  try {
    const requestBody = {
      deptId: values?.deptId ?? null,
      functionId: values?.functionId ?? null,
      name: values?.name ?? null,
      functionCode:values?.functionCode ?? null,
      modifiedBy: values?.modifiedBy ?? null,
      modifiedOn: new Date(),
      createdOn: values?.createdOn,
      createdBy: values?.createdBy ?? 1,
      active: values?.active,
      productCatFamilyMappingId: values?.productCatFamilyMappingId,
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.updateFunctionDetails}`,
      requestBody
    );
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const functionChangeStatusService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.changeFunctionStatus}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
export const onAddFunctionService = async (values) => {
  try {
    const requestBody = {
      deptId: values?.deptId ?? null,
      functionId: values?.functionId ?? null,
      name: values?.name ?? null,
      functionCode:values?.functionCode ?? null,
      modifiedBy: values?.modifiedBy ?? null,
      modifiedOn: values?.modifiedOn ?? null,
      createdOn: values?.createdOn,
      createdBy: values?.createdBy ?? 1,
      active: values?.active ?? true,
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.addFunctionDetails}`,
      requestBody
    );
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
export const fetchNotificationDetailsService = async (values) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.fetchNotificationDetails}`,
      values
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};